module.exports = __webpack_public_path__ + "static/ACABADOTECHO-d85286259d0b22f98f1770fafe6bd04f.webp";